<template>
  <b-field
    :label="label"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
  >
    <b-select
      :value="value"
      :disabled="disabled"
      @input="inputListener"
    >
      <slot />
    </b-select>
  </b-field>
</template>

<script>

import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator (value) {
        return _.isNumber(value) || _.isString(value) || _.isBoolean(value) || value === null || value === undefined;
      }
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
};
</script>
